import { render } from "./PopUpComponent.vue?vue&type=template&id=6194b076&ts=true"
import script from "./PopUpComponent.vue?vue&type=script&lang=ts"
export * from "./PopUpComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__